var map = {
	"./ailments.webp": 8359,
	"./beverages.webp": 5370,
	"./clients.webp": 6796,
	"./default.webp": 1929,
	"./diets.webp": 487,
	"./medications.webp": 4904,
	"./offices.webp": 8637,
	"./prices.webp": 6353,
	"./users.webp": 6640,
	"./validations.webp": 2192
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1523;